import { useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { libraryItemAtom } from "@src/features/libraryItem/libraryItemAtom";

const isCatalogLibraryItemAtom = selectAtom(
  libraryItemAtom,
  (libraryItem) => libraryItem != null && !libraryItem.org,
);

const useIsCatalogLibraryItemPage = (): boolean =>
  useAtomValue(isCatalogLibraryItemAtom);

export default useIsCatalogLibraryItemPage;
